import * as React from 'react';
import { compose } from 'recompose';
import { bem, classnames, use } from '../../lib';
import { Margin, Fluid } from '../../utilities';
import { Icon } from '../Icon';
import { CircularLoading } from 'respinner';
/**
 * Button component
 *
 * @visibleName Button
 */
const ButtonComponent = ({ children, primary, success, danger, disabled, secondary, secondaryBlue, secondarySuccess, secondaryDanger, base, link, cta, onClick, size = '2', className, icon, iconPosition, shortcut, type = 'button', iconButton, tabIndex, linkSecondary, linkPrimary, linkBase, linkDanger, align, loading, tertiary, tertiaryDanger, tertiaryPrimary, tertiarySuccess, minimal, minimalDanger, minimalPrimary, minimalSuccess, toggled, onMouseEnter, onMouseLeave, onMouseOver, onMouseOut }) => {
    const hasNoStyle = !primary &&
        !success &&
        !danger &&
        !secondary &&
        !secondaryBlue &&
        !secondarySuccess &&
        !secondaryDanger &&
        !linkPrimary &&
        !linkBase &&
        !linkSecondary &&
        !linkDanger &&
        !link &&
        !cta &&
        !iconButton &&
        !tertiary &&
        !tertiaryDanger &&
        !tertiaryPrimary &&
        !tertiarySuccess &&
        !minimal &&
        !minimalDanger &&
        !minimalPrimary &&
        !minimalSuccess;
    const clsName = classnames(bem('btn', size ? `--${size.replace('.', '_')}` : null, use(toggled, '--toggled'), use(tertiary, '--tertiary'), use(tertiaryDanger, '--tertiary-danger'), use(tertiaryPrimary, '--tertiary-primary'), use(tertiarySuccess, '--tertiary-success'), use(minimal, '--minimal'), use(minimalDanger, '--minimal-danger'), use(minimalPrimary, '--minimal-primary'), use(minimalSuccess, '--minimal-success'), use(hasNoStyle, '--secondary'), use(primary, '--primary'), use(success, '--success'), use(danger, '--danger'), use(secondary && !iconButton, '--secondary'), use(secondaryBlue, '--secondary-blue'), use(secondarySuccess, '--secondary-success'), use(secondaryDanger, '--secondary-danger'), use(linkPrimary, '--link-primary'), use(linkBase, '--link-base'), use(linkSecondary, '--link-secondary'), use(linkDanger, '--link-danger'), use(base, '--base'), use(link, '--link'), use(cta, '--cta'), use(iconButton, '--icon'), use(iconPosition, `--icon-${iconPosition}`), use(align, `--align-${align}`), use(disabled || loading, '--disabled')), className);
    const btn = (React.createElement("button", { type: type, onClick: onClick, className: clsName, disabled: disabled, tabIndex: tabIndex, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onMouseOver: onMouseOver, onMouseOut: onMouseOut },
        loading && (React.createElement(CircularLoading, { duration: 1, size: 15, className: bem('spinner__svg', '--circular', '--btn') })),
        !loading &&
            icon &&
            (iconPosition === 'left' || iconPosition === undefined) && (React.createElement(Icon, { name: icon })),
        children,
        !loading && icon && iconPosition === 'right' && React.createElement(Icon, { name: icon }),
        shortcut && React.createElement("span", { className: 'btn__shortcut' }, shortcut)));
    return btn;
};
export const Button = compose(Margin(), Fluid())(ButtonComponent);
//# sourceMappingURL=Button.js.map